import { IApplicationState } from '@spinwise/spinwise-core';
import { useSelector } from 'react-redux';
import { HITZ_COUNTRIES, EPageSlugs } from 'Types/globals';

const useLicencedTerms = () => {
  const { geo } = useSelector((state: IApplicationState) => state.globalReducer);

  // likely temp
  if (geo?.code2 === 'DK') return EPageSlugs.TERMS_AND_CONDITIONS;

  if (typeof window !== 'undefined' && localStorage?.getItem('is-mirror') === 'true')
    return EPageSlugs.TERMS_AND_CONDITIONS_MIRROR;

  return geo?.code2 && HITZ_COUNTRIES?.includes(geo?.code2)
    ? EPageSlugs.TERMS_AND_CONDITIONS
    : EPageSlugs.TERMS_AND_CONDITIONS_ANJOUAN;
};

export default useLicencedTerms;
